export * from './BuildingOfficeAltIcon';
export * from './BuildingOfficeAltIcon16Light';
export * from './BuildingOfficeAltIcon16Regular';
export * from './BuildingOfficeAltIcon16Solid';
export * from './BuildingOfficeAltIcon20Light';
export * from './BuildingOfficeAltIcon20Regular';
export * from './BuildingOfficeAltIcon20Solid';
export * from './BuildingOfficeAltIcon24Regular';
export * from './BuildingOfficeAltIcon24Solid';
export * from './BuildingOfficeAltIcon32Regular';
export * from './BuildingOfficeAltIcon64Regular';
